"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M2 6H0v16h20v-2H2zm22-2H14l-2-2H4v16h20zM7 15l4.5-6 3.5 4.51 2.5-3.01L21 15z"
}), 'PermMediaSharp');